(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('multipleUploadStateManager', multipleUploadStateManager);

    multipleUploadStateManager.$inject = ['workflow', 'workspace', 'multipleUploadStorage', 'productFactory'];
    function multipleUploadStateManager(workflow, workspace, multipleUploadStorage, productFactory) {
        var service = {
            setup: setup
        };

        return service;

        // ----------------------------------------------------------------

        function setup(scope) {

            scope.$watch(function () {
                return _.map(workspace.products, createProductInfo);
            }, onProductsChanged, true);

            restoreProducts();
        }

        // -------------------------- Private functions --------------------------

        function onProductsChanged(newProducts, oldProducts) {
            if (angular.equals(newProducts, oldProducts)) {
                return;
            }

            saveProducts();
        }

        function saveProducts() {
            var productsInfo = _.map(workspace.products, function (product) {
                if (angular.isDefined(product.model.id)) {
                    return createProductInfo(product);
                }
            });

            multipleUploadStorage.products(productsInfo);
        }

        function restoreProducts() {
            var storedProducts = multipleUploadStorage.products();

            if (!angular.isArray(storedProducts) || storedProducts.length === 0) {
                return;
            }

            var filteredProducts = _.filter(storedProducts,
                function (productParams) {
                    return angular.isObject(productParams);
                });

            var products = _.map(filteredProducts, function (productParams) {
                return productFactory.createByParams(productParams.modelId,
                                                     productParams.materialId,
                                                     productParams.colourId,
                                                     productParams.scale,
                                                     productParams.quantity);
            });

            workflow.selectProducts(products);
        }

        function createProductInfo(product) {
            return {
                modelId: product.model.id,
                materialId: product.material().id,
                colourId: product.colour().id,
                scale: product.scale(),
                quantity: product.quantity()
            };
        }
    }
})();